import script from "./Notice.vue?vue&type=script&setup=true&lang=js"
export * from "./Notice.vue?vue&type=script&setup=true&lang=js"

import "./Notice.vue?vue&type=style&index=0&id=c5d70b04&lang=scss"

const __exports__ = script;

export default __exports__